import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import DataState from '../../../Types/DataState';
import Page from '../../../Types/Page';
import CustomerComments from '../DashboardTables/CustomerComments';
import ContainerWrapper from './ContainerWrapper';

interface CommentsContainerProps {
  state: string;
  customerComments: Record<string, any>[];
  contactStartDate: string;
  contactEndDate: string;
  contactHandlerId: string;
}

const CommentsContainer: React.FC<CommentsContainerProps> = ({
  state,
  customerComments,
  contactStartDate,
  contactEndDate,
  contactHandlerId,
}: CommentsContainerProps): React.ReactElement => {
  return (
    <>
      <Row spacingInset='400 none' spacing='none'>
        <Heading level={1} type='h400'>
          <FormattedMessage
            id='cs_perfportal_customerComments'
            defaultMessage='Customer comments'
            description='header of Customer Comments Table'
          />
        </Heading>
      </Row>

      <ContainerWrapper
        loading={state === DataState.LOADING}
        loaded={state === DataState.LOADED}
        error={state === DataState.ERROR}
      >
        <Row spacingInset='none none 400' spacing='none'>
          <CustomerComments
            customerMessages={customerComments}
            page={Page.DASHBOARD}
            contactStartDate={contactStartDate}
            contactEndDate={contactEndDate}
            contactHandlerId={contactHandlerId}
          />
        </Row>
      </ContainerWrapper>
    </>
  );
};

export default CommentsContainer;
